export enum PersistedStateKeys {
  CachedToken = 'cachedToken',
}
